import { WhenVisible } from '@inertiajs/react'
import type { ConversationPage } from '@/hooks/usePaginatedConversations'

interface LoadMoreConversationsProps<T> {
  cursor: string | null
  onLoaded: (page: ConversationPage<T>) => void
}

// Infinite-scroll trigger for the conversation lists. Keyed on the cursor so
// each page gets a fresh WhenVisible (it only fetches once per mount).
export function LoadMoreConversations<T>({ cursor, onLoaded }: LoadMoreConversationsProps<T>) {
  if (!cursor) return null

  return (
    <WhenVisible
      key={cursor}
      buffer={400}
      params={{
        data: { cursor },
        only: ['more_conversations'],
        preserveUrl: true,
        onSuccess: (page) => {
          const more = page.props.more_conversations as ConversationPage<T> | undefined
          if (more) onLoaded(more)
        },
      }}
      fallback={
        <div className="flex justify-center py-4">
          <div className="size-5 animate-spin rounded-full border-2 border-primary border-t-transparent" />
        </div>
      }
    >
      <div />
    </WhenVisible>
  )
}
